export var IFrameMessageCallbackType;
(function (IFrameMessageCallbackType) {
    IFrameMessageCallbackType[IFrameMessageCallbackType["RefreshRelatives"] = 1] = "RefreshRelatives";
    IFrameMessageCallbackType[IFrameMessageCallbackType["RelativesLoadingFailed"] = 2] = "RelativesLoadingFailed";
    IFrameMessageCallbackType[IFrameMessageCallbackType["RefreshPrescriptions"] = 3] = "RefreshPrescriptions";
    IFrameMessageCallbackType[IFrameMessageCallbackType["ApplyFilters"] = 4] = "ApplyFilters";
    IFrameMessageCallbackType[IFrameMessageCallbackType["ResetFilters"] = 5] = "ResetFilters";
})(IFrameMessageCallbackType || (IFrameMessageCallbackType = {}));
